import { Percent, ShieldCheck } from "lucide-react";

export const initialPromos = [
  {
    id: 1,
    title: "First Time on the Road? We've Got You",
    subtitle: "Enjoy 20% off on your first 5 TripSecure covers.",
    badge: "20% off",
    cta: "Get this offer",
    href: "/insurance/road-trip",
    icon: Percent,
    accent: "orange",
  },
  {
    id: 2,
    title: "Don't Just Pack",
    subtitle: "Always insure before you hit the road.",
    badge: "Peace of mind",
    cta: "Get covered",
    href: "/insurance/choose",
    icon: ShieldCheck,
    accent: "emerald",
  },
];
